export default __webpack_public_path__ + "static/media/GHSI Board Charter.389fd5eb.pdf";